export default __webpack_public_path__ + "static/media/pavan-heu.4d66e409.jpg";